import { createSelector } from 'reselect'

const clinicians = (state) => state.admin.clinicians

export const cliniciansList$ = createSelector(
  clinicians,
  ({ cliniciansList }) => cliniciansList
)

export const cliniciansLoader$ = createSelector(
  clinicians,
  ({ cliniciansLoader }) => cliniciansLoader
)

export const cliniciansModalLoader$ = createSelector(
  clinicians,
  ({ cliniciansModalLoader }) => cliniciansModalLoader
)

export const activityBillingCodes$ = createSelector(
  clinicians,
  ({ billingCodes }) => billingCodes
)

export const clinicianUserRoles$ = createSelector(
  clinicians,
  ({ clinicianUserRoles }) => clinicianUserRoles
)
